var exports = {
  "gallery": "x61f99309--527072--gallery",
  "gallery--size-2": "x61f99309--527072--gallery--size-2",
  "gallery--size-3": "x61f99309--527072--gallery--size-3",
  "image": "x61f99309--527072--image",
};

module.exports = exports;
